import type { SessionsState } from './state';

export function setSessionExpired(
  state: SessionsState, action: { payload: SessionsState['expired'] },
) {
  state.expired = action.payload;
}
